const NivelToast = {
    EXITO: "success",
    INFO: "info",
    ADVERT: "warn",
    ERROR: "error",
};

export { NivelToast };